module.exports = __webpack_public_path__ + "static/media/money.c9ae793c.svg";